import { useCallback } from 'react';
import { useRouter } from 'next/router';

import useAppState from '../store/store';
import { Analytics } from '../service/analytics';

export enum UploadErrorType {
  FILE,
  GENERAL,
}

const useUploadImage = () => {
  // store
  const addImage = useAppState((state) => state.addImage);
  const setUploadError = useAppState((state) => state.setUploadError);
  const setIsProcessing = useAppState((state) => state.setIsProcessing);

  // router
  const router = useRouter();

  const uploadImage = useCallback(
    (file: File, uploadType: string, pageName: string) => {
      const fileExtension = file.name.split('.').pop();
      Analytics.uploadStart({
        page_name: pageName,
      });

      const fileIsValid = checkFileExtension(file.name);

      if (!fileIsValid) {
        setUploadError(UploadErrorType.FILE);

        Analytics.fileUpload({
          page_name: pageName,
          file_format: fileExtension,
          upload_result: 'fail',
          upload_type: uploadType,
        });
        return;
      }

      try {
        const imageUrl = convertFileToObjectUrl(file);

        Analytics.fileUpload({
          page_name: pageName,
          file_format: fileExtension,
          upload_result: 'success',
          upload_type: uploadType,
        });
        addImage(file, imageUrl);
        router.push('/editor');
        setTimeout(() => {
          setIsProcessing(false);
        }, 3000);
      } catch {
        setUploadError(UploadErrorType.GENERAL);

        Analytics.fileUpload({
          page_name: pageName,
          file_format: fileExtension,
          upload_result: 'fail',
          upload_type: uploadType,
        });
      }
    },
    [addImage, router, setIsProcessing, setUploadError],
  );

  return {
    uploadImage,
  };
};

export default useUploadImage;

function checkFileExtension(fileName: string) {
  return fileName.toLowerCase().match(/\.(jpg|jpeg|png)$/);
}

function convertFileToObjectUrl(file: File) {
  const blob = new Blob([file], { type: file.type });
  return URL.createObjectURL(blob);
}
